import { ROLES } from '../../constants/roles';
import { NURSE_COPY } from './nurseCopy';
import { NURSE_PATHS, getNursingNavItems } from './nursePaths';
import { MAJOR_COPY } from '../major/majorCopy';
import { MAJOR_PATHS, getMajorExtraNavItems } from '../major/majorPaths';

export function getNursingPortalConfig(variant) {
  if (variant === 'major') {
    return {
      variant: 'major',
      requiredRole: ROLES.MAJOR,
      paths: MAJOR_PATHS,
      copy: MAJOR_COPY,
      sidebarStorageKey: 'major-sidebar-collapsed',
      siteSessionPrefix: 'major-active-site',
      portalClassName: 'major-portal nurse-portal nurse-layout',
      topbarSection: MAJOR_COPY.LAYOUT.NAVBAR_BRAND,
      siteGateBadge: 'Ouverture de session major',
      userMenuId: 'major-user-menu',
      getNavItems: ({ showLocalPharmacy }) =>
        getNursingNavItems(MAJOR_PATHS, MAJOR_COPY, {
          showLocalPharmacy,
          extraItems: getMajorExtraNavItems()
        }),
      catalogSectionLabel: MAJOR_COPY.LAYOUT.SIDE_CATALOG_SECTION
    };
  }

  return {
    variant: 'nurse',
    requiredRole: ROLES.NURSE,
    paths: NURSE_PATHS,
    copy: NURSE_COPY,
    sidebarStorageKey: 'nurse-sidebar-collapsed',
    siteSessionPrefix: 'nurse-active-site',
    portalClassName: 'nurse-portal nurse-layout',
    topbarSection: 'Infirmerie',
    siteGateBadge: 'Ouverture de session infirmerie',
    userMenuId: 'nurse-user-menu',
    getNavItems: ({ showLocalPharmacy }) => getNursingNavItems(NURSE_PATHS, NURSE_COPY, { showLocalPharmacy }),
    catalogSectionLabel: null
  };
}
